module.exports = __webpack_public_path__ + "img/quote.cd0b8cbe.png";